import { render, staticRenderFns } from "./ToBeConfirmed.vue?vue&type=template&id=00a1adb8&scoped=true&"
import script from "./ToBeConfirmed.vue?vue&type=script&lang=js&"
export * from "./ToBeConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./ToBeConfirmed.vue?vue&type=style&index=0&id=00a1adb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1adb8",
  null
  
)

export default component.exports